<template>
  <div>
    <page-main
      ref="main"
      :table-data="table"
      :loading="loading"
      @submit="loadGroupData"
      @groupClick="groupClick"
    />
  </div>
</template>

<script>
export default {
  name: "resourceManagement-scm-appraisalGroup",
  components: {
    PageMain: () => import("./components/main")
  },
  data() {
    return {
      table: [],
      loading: false,
      page: {
        curPage: 1,
        pageSize: 1000,
        pageTotal: 0
      }
    };
  },
  methods: {
    loadGroupData() {
      this.loading = true;
      this.$api
        .scmAppraisalGroupListApi({
          ...this.page
        })
        .then(res => {
          this.table = res.body.data;
          this.loading = false;
        });
    },
    groupClick(params) {
      this.$emit("groupClick", params);
    }
  },
  created() {
    this.loadGroupData();
  },
  activated() {
    this.loadGroupData();
  }
};
</script>
